import { createContext } from 'react';
import type { DateLocales } from '../DateLocalization/getDateLocales';

export type AppLocalizationContextValue = {
  appDateLocales: DateLocales;
  decimalSeparator: string;
  use12HourClock: boolean;
};

export const AppLocalizationContext = createContext(
  {} as unknown as AppLocalizationContextValue
);
